import { css } from '@emotion/core';
import { media, variables, tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var font = variables.font;
var colors = tokens.colors;
export var agencyDetails = isPremium => /*#__PURE__*/css("width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;", isPremium && /*#__PURE__*/css("margin-bottom:16px;", media('>=desktop'), "{margin-bottom:0;}"));
export var divider = {
  name: "1n5tfz4",
  styles: "margin:40px 0 16px;"
};
export var agencyInfoBox = {
  name: "dvxtzn",
  styles: "display:flex;flex-direction:column;align-items:center;"
};
export var agencyLogoBox = backgroundColour => /*#__PURE__*/css("height:42px;width:120px;background-color:", backgroundColour || 'transparent', ";margin-bottom:14px;", media('>=desktop'), "{margin-bottom:0;}");
export var agencyLogo = {
  name: "kihw5q",
  styles: "height:100%;width:100%;object-fit:contain;"
};
export var agencyName = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";font-weight:600;margin-bottom:4px;");
export var agencyProfileLink = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";", designTokenFonts.mini, ";text-decoration:underline;text-decoration-color:transparent;transition:text-decoration 0.1s linear;&:hover{text-decoration-color:", colors.neutral.heavy.default, ";}");